var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.29 11.9999L14.83 8.45995C15.0163 8.27259 15.1208 8.01913 15.1208 7.75495C15.1208 7.49076 15.0163 7.23731 14.83 7.04995C14.737 6.95622 14.6264 6.88183 14.5046 6.83106C14.3827 6.78029 14.252 6.75415 14.12 6.75415C13.988 6.75415 13.8573 6.78029 13.7354 6.83106C13.6136 6.88183 13.503 6.95622 13.41 7.04995L9.17 11.2899C9.07628 11.3829 9.00188 11.4935 8.95111 11.6154C8.90035 11.7372 8.87421 11.8679 8.87421 11.9999C8.87421 12.132 8.90035 12.2627 8.95111 12.3845C9.00188 12.5064 9.07628 12.617 9.17 12.7099L13.41 16.9999C13.5034 17.0926 13.6143 17.166 13.7361 17.2157C13.8579 17.2655 13.9884 17.2907 14.12 17.2899C14.2516 17.2907 14.3821 17.2655 14.5039 17.2157C14.6257 17.166 14.7366 17.0926 14.83 16.9999C15.0163 16.8126 15.1208 16.5591 15.1208 16.2949C15.1208 16.0308 15.0163 15.7773 14.83 15.5899L11.29 11.9999Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeft);
export default __webpack_public_path__ + "static/media/angle-left.32b3674a4cfd656a07e602459dd3738e.svg";
export { ForwardRef as ReactComponent };